;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Col, Container, Row } from 'reactstrap';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';
import AgencyTeaser from '../AgencyTeaser';
import SandYouTeaser from '../SandYouTeaser';

type Props = {
  dictionary: Partial<Dictionaries>;
  job: Job;
  locale: Locale;
};

const AgencySection = ({ dictionary, job, locale }: Props): JSX.Element | null => {
  const { formatMessage } = getI18nUtils(dictionary);
  if (!job?.agency) return null;

  const { agency } = job;

  return (
    <Container id="agency">
      <Row>
        <Col md={{ size: 6 }} className="d-flex flex-column justify-content-center align-items-start p-5">
          <div className="mx-xl-5">
            <h2 className="mb-4">
              {formatMessage({ id: 'any' })} <span className="text-primary">{formatMessage({ id: 'questions?' })} </span>
            </h2>
            {formatMessage({ id: 'thankyou_your_agency' }, { agencyName: agency.title })}
          </div>
        </Col>
        <Col md={{ size: 6 }} className="d-flex justify-content-center align-items-center p-5">
          <div className="w-100">
            {process.env.NEXT_PUBLIC_APP === 'sandyou.be' ? (
              <SandYouTeaser dictionary={dictionary} locale={locale} />
            ) : (
              <AgencyTeaser locale={locale} agency={agency} dictionary={dictionary} />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AgencySection;
